<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import { inject } from 'vue'
import { aikuLocaleStructure } from '@/Composables/useLocaleStructure'
import Icon from '@/Components/Utils/Icon.vue'
import { useFormatTime } from '@/Composables/useFormatTime'

const locale = inject('locale', aikuLocaleStructure)

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    data: {}
}>()

</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />
    <Table :resource="data">
        <template #cell(created_at)="{ item }">
            {{ useFormatTime(item.created_at) }}
        </template>

        <template #cell(quantity)="{ item }">
            <span class="">
                {{ locale.number(item.quantity) }} {{ item.quantity > 1 ? 'pcs' : 'pc' }}
            </span>
        </template>

        <template #cell(type)="{ item }">
            <Icon :data="item.type_icon" /> {{ item.type_icon.tooltip }}
        </template>

        <template #cell(price)="{ item }">
            <span class="">
                {{ useFormatCurrency(item.price) }}
            </span>
        </template>

        <template #cell(code)="{ item }">
            <Link :href="route('master.products.show', item.slug)" class="primaryLink">
                {{ item.code }}
            </Link>
        </template>
    </Table>
</template>